/* global axios */
import ApiClient from './ApiClient';

class OnlineDutyAPI extends ApiClient {
  constructor() {
    super('online_duty', { accountScoped: true });
  }

  pending(params = {}) {
    return axios.get(`${this.url}/pending`, { params });
  }

  inProgress(params = {}) {
    return axios.get(`${this.url}/in_progress`, { params });
  }

  claim(conversationId) {
    return axios.post(`${this.url}/${conversationId}/claim`, {});
  }

  latestPendingSupport(params = {}) {
    return axios.get(`${this.url}/support/latest`, { params });
  }

  updateSupportStatus(conversationId, { status, agentComment } = {}) {
    return axios.put(`${this.url}/${conversationId}/support`, {
      status,
      agentComment,
    });
  }
}

export default new OnlineDutyAPI();
